import { Alert, Flex } from '@wyz/ui';
import { Trans } from '~/common/context';

type Props = {
  maxSearchExceeded: boolean;
  hasNoResults: boolean;
  count: number | undefined;
};
function SearchErrors({ maxSearchExceeded, hasNoResults, count }: Props) {
  return (
    <Flex alignItems='center' justifyContent='end' className='w-100'>
      {maxSearchExceeded && (
        <Alert variant='danger' className='mt-1'>
          <Trans
            i18nKey='app.purchase.search_page.search_max_count'
            values={{
              count,
            }}
          />
        </Alert>
      )}
      {hasNoResults && (
        <Alert variant='danger' className='mt-1'>
          <Trans i18nKey='app.purchase.search_page.no_results' />
        </Alert>
      )}
    </Flex>
  );
}

export default SearchErrors;
